import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PuntPlaySelection } from "./PuntPlaySelection";
import { PuntLog } from "./PuntLog";
import { PuntTackleLog } from "./PuntTackleLog";
import { DefenseTurnoverLog } from "../Defense/DefenseTurnoverLog";
import { PenaltyLog } from "../Components/PenaltyLog";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { useLogger } from "../../../../contexts/LoggerContext";

export const PuntLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  const { puntPlayers } = useDepthChart();
  const { clearSelections } = useLogger();


  useEffect(() => {
    if (clearSelections) {
      setExpandedAccordion("play-selection");
    }
  }, [clearSelections]);

  return (
    <Paper elevation={3} sx={{ p: 1, margin: "0 auto", maxWidth: 1140 }}>
      <Box>
        {/* Play Selection */}
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PuntPlaySelection />
          </AccordionDetails>
        </Accordion>

        {/* Punt Log */}
        <Accordion
          expanded={expandedAccordion === "kickoff-log"}
          onChange={handleAccordionChange("kickoff-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="kickoff-log-content"
            id="kickoff-log-header"
          >
            <Typography>Punt Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PuntLog />
          </AccordionDetails>
        </Accordion>

        {/* Tackle Log */}
        <Accordion
          expanded={expandedAccordion === "tackle-log"}
          onChange={handleAccordionChange("tackle-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="tackle-log-content"
            id="tackle-log-header"
          >
            <Typography>Tackle Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PuntTackleLog />
          </AccordionDetails>
        </Accordion>

        {/* Takeaway Log */}
        <Accordion
          expanded={expandedAccordion === "takeaway-log"}
          onChange={handleAccordionChange("takeaway-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="takeaway-log-content"
            id="takeaway-log-header"
          >
            <Typography>Takeaway Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DefenseTurnoverLog />
          </AccordionDetails>
        </Accordion>

        {/* Penalty Log */}
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="penalty-log-content"
            id="penalty-log-header"
          >
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PenaltyLog players={puntPlayers} />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};
